// extracted by mini-css-extract-plugin
export default {"result_title_block":"ResultTitle_result_title_block__lHphv","result_title_sum":"ResultTitle_result_title_sum__2v4+S"};